export default [
  {
    path: '/edo',
    name: 'Edo',
    component: () => import('@/views/Edo/Index.vue'),
    redirect: { name: 'EdoReestrList' },
    children: [
      {
        path: 'reestr',
        name: 'EdoReestrList',
        component: () => import('@/views/Edo/EdoReestrList.vue')
      },
      {
        path: 'changelog',
        name: 'EdoChangelog',
        component: () => import('@/views/Edo/EdoChangelog.vue')
      }
    ]
  }
]
